<template>
  <div v-if="canCreateNewSubmission" class="mb-4 w-100">
    <b-card no-body class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="mr-2 font-weight-bold resubmission-notice">
          You have one more chance to submit. Please try again.
        </div>
        <b-button
          ref="button__create-new-submission"
          class="button__create-new-submission"
          variant="outline-primary"
          :disabled="isLoading"
          @click="resubmit"
        >
          <b-spinner v-if="isLoading" variant="primary" small />
          <div v-else>Create new submission</div>
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import EvidenceSubmission from '@/models/EvidenceSubmission';

export default {
  name: 'CreateNewSubmissionCard',

  props: {
    learningUnitId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    evidenceSubmissions() {
      return EvidenceSubmission.query()
        .where('user_id', this.userId)
        .where('learning_unit_id', this.learningUnitId)
        .get();
    },

    canCreateNewSubmission() {
      return this.evidenceSubmissions.every((es) => es.isDenied);
    }
  },

  methods: {
    async resubmit() {
      this.isLoading = true;
      try {
        const result = await EvidenceSubmission.api().resubmit(this.learningUnitId);

        /* delete oldest evidence due to have to show only 2 evidences */
        const evidenceSubmissions = EvidenceSubmission.query()
          .where({
            user_id: this.userId,
            learning_unit_id: this.learningUnitId
          })
          .orderBy('submitted_no')
          .get();

        if (evidenceSubmissions.length > 2) {
          EvidenceSubmission.delete(evidenceSubmissions[0].id);
        }

        // Emit the new submission ID to parent component
        this.$emit('submission-created', result.response.data.id);
        this.$toast.success('Create new submission successfully');
      } catch (error) {
        console.error(error);
        this.$toast.error('Cannot submit your evidence, please try again');
      }
      this.isLoading = false;
    }
  }
};
</script>
<style scoped lang="scss">
.resubmission-notice {
  color: #3b3e66;
  font-weight: bold;
  font-size: 16px;
}
.button__create-new-submission {
  cursor: pointer;
}
</style>
